import { DateRangeElement } from "@portal/BaseComponents/Filters/Elements/DateRange/DateRangeElement";
import { DateRangeString } from "@portal/BaseComponents/Filters/Elements/DateRange/type";
import {
  allRelativeOptions,
  getDateRangeText,
} from "@portal/BaseComponents/Filters/Elements/DateRange/utils";
import { FilterDropdownDown } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropdownDown";
import { useFormats } from "@portal/hooks/use-formats";
import useOpen from "@portal/hooks/useOpen";
import { invoiceFiltersAtom } from "@portal/store/Filters/Invoices/invoice-filter";
import { resetPage, tableAtom } from "@portal/store/table/table";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";

function DueDateFilter() {
  const { onClose, open, toggleOpen, handleOpenChange } = useOpen({
    open: false,
  });
  const setTable = useSetAtom(tableAtom);
  const [invoiceFilters, setInvoiceFilters] = useAtom(invoiceFiltersAtom);
  const { dateformat } = useFormats();
  function handleHideReset() {
    return Object.values({
      from: invoiceFilters.filterValues.from_due_date,
      to: invoiceFilters.filterValues.to_due_date,
      type: invoiceFilters.filterValues.due_date_range,
    }).includes(undefined)
      ? true
      : false;
  }
  function handleSubmit(value: DateRangeString) {
    setInvoiceFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.due_date_range = value.type;
        draft.filterValues.from_due_date = value.from;
        draft.filterValues.to_due_date = value.to;
        return draft;
      });
    });
    onClose();
    setTable(resetPage);
  }
  const Content = (
    <DateRangeElement
      value={{
        from: invoiceFilters.filterValues.from_due_date,
        to: invoiceFilters.filterValues.to_due_date,
        type: invoiceFilters.filterValues.due_date_range,
      }}
      onSubmit={handleSubmit}
      onCancel={onClose}
      additionalProps={{
        options: allRelativeOptions,
      }}
    />
  );

  function handleReset() {
    setInvoiceFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.due_date_range = undefined;
        draft.filterValues.from_due_date = undefined;
        draft.filterValues.to_due_date = undefined;
        return draft;
      });
    });
    onClose();
  }

  const hideReset = handleHideReset();
  return (
    <FilterDropdownDown
      filterBlockProps={{
        isDefault: true,
        toggleOpen,
        open,
        title: "Due Date",
        filterValues: getDateRangeText(
          {
            from: invoiceFilters.filterValues.from_due_date,
            to: invoiceFilters.filterValues.to_due_date,
            type: invoiceFilters.filterValues.due_date_range,
          },
          dateformat
        ),
        onReset: handleReset,
        hideReset,
      }}
      filterComponent={Content}
      filterTitle={"Due Date"}
      onopenChange={handleOpenChange}
    />
  );
}

export { DueDateFilter };
